import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import session from './sessionReducer';
import registration from './registrationReducer';
import auth from './authReducer';
import profile from './profileReducer';
import app from './appReducer';
import policy from './policyReducer';
import claim from './claimReducer';
import payment from './paymentReducer';
import admin from './adminReducer';

const createRootReducer = history =>
	combineReducers({
		router: connectRouter(history),
		app,
		admin,
		session,
		profile,
		claim,
		payment,
		policy,
		registration,
		auth
	});

export default createRootReducer;
